import {
    ArticleFetchFailureAction,
    ArticleFetchRequestAction,
    ArticleFetchSuccessAction,
    ARTICLE_FETCH_FAILURE,
    ARTICLE_FETCH_REQUEST,
    ARTICLE_FETCH_SUCCESS,
} from 'mk2/apps/blogs/containers/Article/Article.actions';
import { tupdate } from 'mk2/helpers/types';
import { errorMessage } from 'mk2/reducers/errorMessage';
import { loadingState, LoadingState } from 'mk2/reducers/loadingState';
import { Reducer } from 'redux';

export interface ArticleState {
    articleId: number | null;
    suggestedArticleIds: number[];
    suggestedArticlesHomepagePhotos: {[articleId: number]: number};
    loadingState: LoadingState;
    errorMessage: string;
}

export const initialArticleState: ArticleState = {
    articleId: null,
    suggestedArticleIds: [],
    suggestedArticlesHomepagePhotos: {},
    loadingState: LoadingState.INIT,
    errorMessage: null,
};

export interface ArticlesState {
    [key: string]: ArticleState;
}

const initialArticlesState: ArticlesState = {};

declare type ArticlesReducerAction =
    ArticleFetchRequestAction
    | ArticleFetchSuccessAction
    | ArticleFetchFailureAction;

const articlesReducer: Reducer<ArticlesState> = (state = initialArticlesState, action: ArticlesReducerAction) => {
    switch (action.type) {
        case ARTICLE_FETCH_REQUEST:
        case ARTICLE_FETCH_FAILURE: {
            const key = `${action.username}/${action.articleSlug}`;
            return tupdate(state, {
                [key]: tupdate(state[key] || initialArticleState, {
                    loadingState: loadingState(undefined, action),
                    errorMessage: errorMessage(undefined, action),
                }),
            });
        }

        case ARTICLE_FETCH_SUCCESS: {
            const key = `${action.username}/${action.articleSlug}`;
            return tupdate(state, {
                [key]: tupdate(state[key] || initialArticleState, {
                    articleId: action.response.result.article,
                    suggestedArticleIds: action.response.result.suggestedArticles,
                    suggestedArticlesHomepagePhotos: action.response.result.suggestedArticlesHomepagePhotos,
                    loadingState: loadingState(undefined, action),
                    errorMessage: errorMessage(undefined, action),
                }),
            });
        }

        default:
            return state;
    }
};

export default articlesReducer;
